import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
// eslint-disable-next-line prettier/prettier
import type { 
  TimesheetsEntryTotalResponseType,
  TimesheetEntryDeleteResponseType,
  TimesheetsEntryMutateResponseType,
  TimesheetsEntryResponseType,
} from '@/api/types/response/TimesheetsResponseType'
import type { TimesheetsType } from '@/api/types/general/TimesheetsType'

/**
 * @property string apiEnd /api/timesheets/entry
 */
export default class TimesheetsEntryApi extends AbstractApi {
  summary(start?: string, end?: string): Promise<TimesheetsEntryTotalResponseType> {
    let url = `${this.apiEnd}/total`

    if (start && end) {
      url += `?start=${start}&end=${end}`
    }

    return httpClient.get(url)
  }

  timesheets(date: string): Promise<TimesheetsEntryResponseType> {
    return httpClient.get(`${this.apiEnd}?start=${date}&end=${date}`)
  }

  delete(id: number): Promise<TimesheetEntryDeleteResponseType> {
    return httpClient.delete(`${this.apiEnd}/${id}`)
  }

  create(payload: TimesheetsType): Promise<TimesheetsEntryMutateResponseType> {
    return httpClient.post(this.apiEnd, {
      timesheets: [payload],
    })
  }

  update(payload: TimesheetsType): Promise<TimesheetsEntryMutateResponseType> {
    return httpClient.put(this.apiEnd, {
      timesheets: [payload],
    })
  }
}
